import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import TrapSiteForm from "./TrapSiteForm";
import validateForm from "./TrapSiteValidation";
import { useWebServer } from "../../../../../providers";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { createTrapSite } from "../../../../../actions";
import { displayErrorNotification } from "../../../../../actions/notifications";
import { countyForSave } from "./TrapSiteForm/countyPayload";
import { useSiteGroups } from "../SiteGroups/useSiteGroups";
import { SiteGroupsField } from "../SiteGroups/SiteGroupsField";

const TrapSiteCreate = ({ createTrapSite, displayErrorNotification, ...otherProps }) => {
  const { sendRequest } = useWebServer();
  const history = useHistory();
  const siteGroups = useSiteGroups();
  const [groupIds, setGroupIds] = useState([]);

  const onSave = async ({ county, ...trapSite }) => {
    const typed = countyForSave(county, "");
    const created = await createTrapSite(typed ? { ...trapSite, county: typed } : trapSite, sendRequest);
    const id = created?._id ?? created?.id;
    if (groupIds.length && id != null) {
      try {
        await siteGroups.setSiteGroups(id, groupIds);
      } catch (err) {
        displayErrorNotification("The collection site was saved, but its groups were not. Choose them again here.");
        history.push(ROUTES.editTrapSite.replace(":id", id));
        return;
      }
    }
    history.push(ROUTES.trapSite);
  };

  return (
    <TrapSiteForm
      {...otherProps}
      onSave={onSave}
      extraFields={
        <SiteGroupsField groups={siteGroups.groups} value={groupIds} onChange={setGroupIds} disabled={siteGroups.loading} />
      }
    />
  );
};

const formWrapped = reduxForm({
  form: "TrapSiteCreate",
  validate: validateForm,
})(TrapSiteCreate);

export default connect(null, { createTrapSite, displayErrorNotification })(formWrapped);
